import { PaymentGateway } from './payment.types';

// User Types
export interface UserDto {
  id: number;
  email: string;
  username: string;
  role: string;
  locale: string;
  race?: string;
  money: number;
  rouletteTokens?: number;
  createdAt: string;
  hasUnvotedPolls: boolean;
  /**
   * Способы оплаты, закрытые этому пользователю: на странице пополнения их не показываем совсем.
   * Состав индивидуальный и меняется, поэтому берём только отсюда. Бэк такой способ и не примет —
   * `POST /payments` вернёт 400 с готовым текстом в `message`. Поле кешируется у бэка до двух часов,
   * так что сразу после выполнения условия оно какое-то время приходит старым — это нормально,
   * ничего не опрашиваем, рисуем то, что пришло.
   */
  blockedPaymentMethods?: PaymentGateway[];
}

export interface ChangeLocaleDto {
  locale: 'ru' | 'en' | 'uk';
}

export interface ChangeUsernameDto {
  username: string;
}

// L2 Account Types
export interface AccountDto {
  login: string;
}

export interface PaginatedAccountDto {
  content: AccountDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
  canCreateMore: boolean;
}

export interface CreateAccountDto {
  login: string;
  password: string;
}

export interface ChangePasswordAccountDto {
  login: string;
  oldPassword: string;
  newPassword: string;
}

export interface AccountForgotPasswordDto {
  password: string;
  accountForgotPasswordToken: string;
}

// L2 Character Types
export enum Race {
  HUMAN = 'HUMAN',
  ELF = 'ELF',
  DARK_ELF = 'DARK_ELF',
  ORC = 'ORC',
  DWARF = 'DWARF'
}

export interface CharacterDto {
  charName: string;
  accountName: string;
  level: number;
  online: boolean;
  race: Race;
}

export interface PaginatedCharacterDto {
  content: CharacterDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
}
